import axios from "axios";
import { AttachmentFieldFormTypeUpdate } from "../models/requests/AttachmentFieldFormTypeUpdate";
import { AttachmentFieldFormTypeResult } from "../models/responses/AttachmentFieldFormTypeResult";

const baseUrl = "/AutoConnectSSO/api/InscriptionFlow/InscriptionFlows";
function getFormTypeUrl(idAttachmentField: number, formTypeId: number) {
  return `/AttachmentFieldFormType/${idAttachmentField}/${formTypeId}`;
}

const instance = axios.create({
  baseURL: baseUrl,
  withCredentials: true
});

async function setFormType(
  idAttachmentField: number,
  formTypeId: number,
  attachmentFieldFormType: AttachmentFieldFormTypeUpdate
) {
  return await instance.post<AttachmentFieldFormTypeUpdate>(
    getFormTypeUrl(idAttachmentField, formTypeId),
    attachmentFieldFormType
  );
}

async function getFormType(idAttachmentField: number, formTypeId: number) {
  const url = getFormTypeUrl(idAttachmentField, formTypeId);
  return instance.get<AttachmentFieldFormTypeResult>(url);
}

export const AutonomousFormAttachmentFieldFormTypeService = {
  setFormType,
  getFormType
};
